module.exports = __webpack_public_path__ + "static/media/news_01.3e352388.jpg";